var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"v-btn__fab",attrs:{"color":"accent"},nativeOn:{"click":function($event){return _vm.openCadastroKpis()}}},[_vm._v(" "+_vm._s(_vm.$t('label.kpis_consultar_kpis'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }